import {
  InpiDepositDeclarationBeneficiary,
  InpiDepositDeclarationBeneficiaryJson
} from './inpi-deposit-declaration-beneficiary';

export interface InpiDepositDeclarationJson {
  head_office: {
    street?: string;
    postal_code?: string;
    city?: string;
    insee_code?: string;
  };
  users: InpiDepositDeclarationBeneficiaryJson[];
}

export class InpiDepositDeclaration {
  constructor(
    public street?: string,
    public postalCode?: string,
    public city?: string,
    public inseeCode?: string,
    public beneficiaries?: InpiDepositDeclarationBeneficiary[]
  ) {}

  static toJson(inpiDeposit: InpiDepositDeclaration): InpiDepositDeclarationJson {
    return {
      head_office: {
        street: inpiDeposit.street,
        postal_code: inpiDeposit.postalCode,
        city: inpiDeposit.city,
        insee_code: inpiDeposit.inseeCode
      },
      users: inpiDeposit.beneficiaries
        ? inpiDeposit.beneficiaries.map(beneficiary => InpiDepositDeclarationBeneficiary.toJson(beneficiary))
        : []
    };
  }
}
